import { OutputData } from '@editorjs/editorjs'

import { IBase, SECTION_THEME_ENUM } from './base'
import { IEmployeeReduced } from './employee'

export enum TEAM_CATEGORY_TYPE_ENUM {
	MEDICAL_PERSONNEL = 'MEDICAL_PERSONNEL'
}

export interface ITeamCategoryReduced extends IBase {
	name: string
	namePlural: string
	slug: string
	employees: IEmployeeReduced[]
	sectionTitle: string
	sectionText: OutputData
	sectionTheme: SECTION_THEME_ENUM
	type: TEAM_CATEGORY_TYPE_ENUM | null
	sortOrder?: number | null
}

export interface ITeamCategory extends ITeamCategoryReduced {}
